import { useQuery } from '@tanstack/react-query';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

import { PageHeader } from '../../../components/ui/PageHeader.jsx';
import { Button } from '../../../components/ui/Button.jsx';
import { productsApi } from '../../../api/products.js';

import { ProductForm } from './ProductForm.jsx';

/**
 * Dedicated product create/edit page. Loads the full product (with the variant
 * view) when editing, then mounts the seeded form. Replaces the old modal so
 * the form has room for the gallery, variants and ORME readings.
 */
export function ProductEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const editing = Boolean(id);

  const productQuery = useQuery({
    queryKey: ['products', 'detail', id],
    queryFn: () => productsApi.get(id),
    enabled: editing
  });

  const product = editing ? productQuery.data : null;
  const ready = !editing || (!productQuery.isLoading && product);

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title={editing ? (product ? `Modifica ${product.name}` : 'Modifica prodotto') : 'Nuovo prodotto'}
        description={editing ? 'Dati, immagini, letture ORME e varianti.' : 'Crea un nuovo prodotto base.'}
        actions={<Button variant="ghost" onClick={() => navigate('/admin/products')}><ArrowLeft className="mr-1 h-4 w-4" /> Prodotti</Button>}
      />

      {editing && productQuery.isError ? (
        <p className="text-sm text-danger">Prodotto non trovato.</p>
      ) : !ready ? (
        <p className="text-sm text-ink-muted">Caricamento...</p>
      ) : (
        <ProductForm key={id || 'new'} product={product} editing={editing} />
      )}
    </div>
  );
}
